import ValidationRules from '../Data/ValidationRules';
let Quote = require('../Managers/Quote.js');

import moment from 'moment';

module.exports = {
    validObject() {
        return {
            isValid: true,
            hasError: false,
            errors: [],
        };
    },

    validate(inputValidationType, inputValue, options) {
        if (window.uornorb(inputValidationType)) {
            return this.validObject();
        }

        if (!options) {
            options = {};
        }
        let validationChunks = [];

        validationChunks = inputValidationType.split('.');
        inputValidationType = validationChunks[0];

        let validationRules = ValidationRules;
        let result = validationRules.map((validationRulesJson) => {
            let allErrorMessages = [];
            let validationResult = this.success();
            if (validationChunks[1] === 'mandatory') {
                validationRulesJson[inputValidationType]['not_null'] = {
                    error: "This field is required"
                };
            }
            $.map(validationRulesJson[inputValidationType], (validationParamAndErrorMessage, validationMethod) => {
                let validationResult = this[validationMethod](inputValue, validationParamAndErrorMessage, options);
                if (validationResult.errors && validationResult.errors.length > 0) {
                    allErrorMessages = allErrorMessages.concat(validationResult.errors);
                }
            });

            if (allErrorMessages.length > 0) {
                return {
                    isValid: false,
                    hasError: true,
                    errors: allErrorMessages
                };
            } else {
                return validationResult;
            }
        });

        if (validationChunks[1] === 'non_mandatory' && window.uornorb(inputValue)) {
            return {
                0 : {
                    isValid: true,
                    hasError: false,
                    errors: []
                }
            };
        }

        return result;
    },

    success() {
        return {
            isValid: true,
            hasError: false,
        };
    },

    failure(errorMessage) {
        let errorArray = [];
        if (errorMessage) {
            errorArray.push(errorMessage);
        }
        return {
            isValid: false,
            hasError: true,
            isHelpVisible: false,
            errors: errorArray,
        };
    },

    not_null: function(inputValue, validationValues) {
        if (inputValue === null || inputValue === undefined || inputValue === "" || inputValue === " ") {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    not_true: function(inputValue, validationValues) {
        if (inputValue === false || window.uornorb(inputValue)) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    minimum: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] > parseInt(inputValue).toString().length || parseInt(inputValue) < 0) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    maximum: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] < parseInt(inputValue).toString().length) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    too_young: function(inputValue, validationValues) {
        if (moment(inputValue).isAfter(validationValues['value'])) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    too_old: function(inputValue, validationValues) {
        if (moment(inputValue).isBefore(validationValues['value'])) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    too_soon: function(inputValue, validationValues) {
        if (moment(inputValue).isBefore(moment(), 'day')) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    no_future_dates: function(inputValue, validationValues) {
        if (moment(inputValue).isBefore(validationValues['value'])) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    regex_check: function(inputValue, validationValues) {
        if (validationValues['value'].test(inputValue)) {
            return this.success();
        } else {
            return this.failure(validationValues['error']);
        }
    },

    /**
     * ensure that the inputValue matches against the value of
     * the DOM element with an ID of options.matchTo
     * @param  {string} inputValue
     * @param  {object} validationValues
     * @param  {object} options
     * @param  {string} options.matchTo
     * @return {object|array}
     */
    match: function(inputValue, validationValues, options) {
        let matchToValue = document.getElementById(options.matchTo).value;
        if (inputValue != matchToValue) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    doesLettingRefereeNumbersMatchApplication(field) {
        let applicationMobile = Quote.getByPath('BaseIndividualApplication.mobile');
        let applicationPhone = Quote.getByPath('BaseIndividualApplication.phone');
        let number = Quote.getByPath('BaseIndividualApplication.lettingReferee.' + field);

        let isSame = false;
        if (!window.uornorb(applicationPhone)) {
            if (applicationPhone == number) {
                isSame = true;
            }
        }

        if (!window.uornorb(applicationMobile)) {
            if (applicationMobile == number) {
                isSame = true;
            }
        }

        if (isSame) {
            return {
                isValid: false,
                hasError: true,
                errors: ["Mobile number and telephone number must not be the same as tenant contact details"],
            };
        } else {
            return {
                isValid: true,
                hasError: false,
                errors: [],
            };
        }
    },

    doesFinancialRefereeNumberMatchApplication(index, field) {
        let applicationMobile = Quote.getByPath('BaseIndividualApplication.mobile');
        let applicationPhone = Quote.getByPath('BaseIndividualApplication.phone');
        let number = Quote.getByPath('BaseIndividualApplication.financialReferees.' + index + '.'+field);

        let isSame = false;
        if (!window.uornorb(applicationPhone)) {
            if (applicationPhone == number) {
                isSame = true;
            }
        }

        if (!window.uornorb(applicationMobile)) {
            if (applicationMobile == number) {
                isSame = true;
            }
        }

        if (isSame) {
            return {
                isValid: false,
                hasError: true,
                errors: ["Mobile number and telephone number must not be the same as tenant contact details"],
            };
        } else {
            return {
                isValid: true,
                hasError: false,
                errors: [],
            };
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Managers/Validation.js